<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow menu-light"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
    style="font-family: 'NanumBarunGothic';"
  >
    <!-- main menu header-->
    <div class="d-flex align-items-center" style="height: 10%;">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul>
          <!-- Logo & Text -->
          <li>
            <b-link to="/">
              <span>
                <b-img :src="appLogoImage" alt="logo" style="width: 100%; margin-left: -2px;"/>
              </span>
              <!-- <h4 class="title-text">
                {{ appName }}
              </h4> -->
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom"/>

    <!-- main menu content-->
    <!-- <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <template
        v-if="
          $router.currentRoute.name &&
          !$router.currentRoute.name.startsWith('account') &&
          !$router.currentRoute.name.startsWith('custom')
        "
      >
        <li
          class="nav-item custom-menu-elements"
          style="margin-top: 50px; margin-bottom: 0px; margin-left: 10px; margin-right: 10px;"
        >
          <h4><b>
            Current Category
          </b></h4>
          <vue-select
            class="category-select"
            style="margin-bottom: 120px;"
            label="title"            
            :options="categoryList"
            :clearable="false"
            v-model="selectedCategory"
            
            placeholder="Select Category"
          >
          </vue-select>
        </li>
        <li class="nav-item custom-menu-elements" > 
          <b-button 
            to="/competition"
            v-if="hasReadPermission('competition')"
            variant="primary"
            size="lg"
            block
          >
            COMPETITION
          </b-button>
        </li>
        <li class="nav-item custom-menu-elements" > 
          <b-button
            to="/trendkeyword"
            v-if="hasReadPermission('trendkeyword')"
            variant="primary"
            size="lg"
            block
          >
            TREND KEYWORD
          </b-button>
        </li>
        <li class="nav-item custom-menu-elements" > 
          <b-button
            to="/insight"
            v-if="hasReadPermission('insight')"
            variant="primary"
            size="lg"
            block
          >
            INSIGHT
          </b-button>
        </li>
        <li class="nav-item custom-menu-elements" > 
          <b-button
            to="/tracking"
            v-if="hasReadPermission('tracking')"
            variant="primary"
            size="lg"
            block
          >
            TRACKING
          </b-button>
        </li>
        <li class="nav-item custom-menu-elements" > 
          <b-button
            to="/brandindex"
            v-if="hasReadPermission('brandindex')"
            variant="primary"
            size="lg"
            block
          >
            BRAND INDEX
          </b-button>
        </li>
        <li class="nav-item custom-menu-elements" style="">
          <b-button
            variant="secondary"
            size="lg"
            @click="openCreateCampaignModal(null, null)"
            block
          >
            USER GUIDE
          </b-button>
        </li>
      </template>
    </vue-perfect-scrollbar> -->










    












    <div style="height: 90%;">



      <b-navbar-nav class="nav align-items-center ml-auto">
        <b-nav-item-dropdown
          right
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-user"
          ref="dropdown-user"
        >
          <template #button-content>
            <b-avatar
              size="30"
              variant="light-primary"
              badge
              :src="require('@/assets/images/avatars/user-small.png')"
              class="badge-minimal mr-1"
              badge-variant="success"
            />
            <div class="d-sm-flex d-none user-nav">
              <p class="user-name font-weight-bolder mb-0">{{ userData.name }}</p>
              <!-- <span class="user-status">{{ userData.username }}</span> -->
            </div>
          </template>
          <b-dropdown-form>
            <b-row class="d-flex align-items-center" style="min-width: 17rem;">
              <b-col cols="10">
                <p class="user-name font-weight-bolder mb-0">
                  {{ userData.name }}
                </p>
                <small>{{ userData.username }}</small>
              </b-col>
              <b-col cols="2">
                <feather-icon
                  class="cursor-pointer"
                  @click="openMyInfo"
                  icon="EditIcon"
                />
              </b-col>
            </b-row>
          </b-dropdown-form>

          <b-dropdown-divider />
          <b-dropdown-form>
            <b-row class="d-flex align-items-center">
              <b-col 
                cols="6"
                v-if="hasAdminRole() || hasSuperAdminRole()"
              >
                <b-button
                  variant="outline-primary"
                  class="full-width"
                  @click="openSetting"
                >
                  <span class="align-middle">Setting</span>
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-button
                  variant="outline-primary"
                  class="full-width"
                  @click="logout"
                >
                  <span class="align-middle">Logout</span>
                </b-button>
              </b-col>
            </b-row>
          </b-dropdown-form>
        </b-nav-item-dropdown>
      </b-navbar-nav>



      <div style="height: 8%; margin-top: 10%; margin-bottom: 10%; margin-left: 10px; margin-right: 10px;">
        <h4>
            Keyword Search
        </h4>
        <div>
          <b-form-input
            v-model="searchKeyword"
            placeholder="Search..."
            type="text"
            @keyup.native="keywordSearch"
          />
        </div>
      </div>


      <hr style="margin: 10px; height: 2px;  background-color : lightgray; border: 0;">

      <div style="height: 12%; margin-top: 10%; margin-bottom: 0px; margin-left: 10px; margin-right: 10px;">
        <h4>
            Current Category
        </h4>
        <vue-select
          class="category-select"
          label="title"            
          :options="categoryList"
          :clearable="false"
          v-model="selectedCategory"          
          placeholder="Select Category"
        >
        </vue-select>
      </div>


      


      
      <div id="mainMenu" class="custom-menu-elements" style="height: 55%;">
        <b-form-radio
          class="btn-radio"
          v-if="hasReadPermission('marketoverview')"
          v-model="selectedMenu"
          value="marketoverview"
          size="lg"
          button
          @change="cisMenuClick('marketoverview')"
          style="display: block !important; margin: 15px 0px;"
        >
          MARKET OVERVIEW
        </b-form-radio>
        <b-form-radio
          class="btn-radio"
          v-if="hasReadPermission('competition')"
          v-model="selectedMenu"
          value="competition"
          size="lg"
          button
          @change="cisMenuClick('competition')"
          style="display: block !important; margin: 15px 0px;"
        >
          SHARE OF SEARCH
        </b-form-radio>
        <b-form-radio
          class="btn-radio"
          v-if="hasReadPermission('trendkeyword')"
          v-model="selectedMenu"
          value="trendkeyword"
          size="lg"
          button
          @change="cisMenuClick('trendkeyword')"
          style="display: block !important; margin: 15px 0px;"
        >
          CATEGORY TREND
        </b-form-radio>
        <b-form-radio
          class="btn-radio"
          v-if="hasReadPermission('brandpin')"
          v-model="selectedMenu"
          value="searchtag"
          size="lg"
          button
          @change="cisMenuClick('searchtag')"
          style="display: block !important; margin: 15px 0px;"
        >
          SEARCH TAG
        </b-form-radio>
        <b-form-radio
          class="btn-radio"
          v-if="hasReadPermission('insight')"
          v-model="selectedMenu"
          value="insight"
          size="lg"
          button
          @change="cisMenuClick('insight')"
          style="display: block !important; margin: 15px 0px;"
        >
          INSIGHT
        </b-form-radio>
        <b-form-radio
          class="btn-radio"
          v-if="hasReadPermission('tracking')"
          v-model="selectedMenu"
          value="tracking"
          size="lg"
          button
          @change="cisMenuClick('tracking')"
          style="display: block !important; margin: 15px 0px;"
        >
          TRACKING
        </b-form-radio>
      </div>
      <div style="margin-bottom: 10px;" >
        <hr style="margin: 10px; height: 2px;  background-color : lightgray; border : 0;"> 
        <div class="d-flex justify-content-center" style="margin-bottom: 5px; margin-top: 5px;">
          <div class="d-flex align-items-center" style="width: 45%; height: 22px; margin: 2px 2px 5px 5px;">
            <b-button
              variant="secondary"
              size="sm"
              @click="openAbout()"
              block
            >
              🏢 <b>ABOUT</b>
            </b-button>
          </div>
          <div class="d-flex align-items-center" style="width: 45%; height: 22px; margin: 2px 5px 5px 2px;">
            <b-button
              variant="secondary"
              size="sm"
              @click="downGuide()"
              block
            >
              📋 <b>GUIDE</b>
              <!-- 📖 <b>GUIDE</b> -->
            </b-button>
          </div>
        </div>   

        <div class="d-flex align-items-center" style="height: 22px; margin: 10px;" v-if="hasSuperAdminRole()">
          <b-button
            size="sm"
            @click="showAiAgent()"
            block
            style="background-color: steelblue !important;"
            :disabled="!isActiveAiAgent"
          >
            ✨ <b>AI SERVICE</b> <sup style="font-family: Verdana, sans-serif; font-size: 9px; color: orange;">βeta</sup>
          </b-button>
        </div>
      </div>
    </div>

    
    
    <keyword-search-modal 
      ref="keywordSearchModal"
      :searchKeyword="searchKeyword"
    />

  </div>

  

</template>

<script>
import { getCampaignsMenu } from "@/navigation/vertical";
import AdaccountService from "@/services/ad-account.service";
import CategoryService from "@/services/category.service";
import navSettingMenuItems from "@/navigation/verticalSetting";
import navTargetMenuItems from "@/navigation/verticalTargets";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
  BLink,
  BImg,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BFormSelect,
  BFormRadio,

  
  BNav,
  BNavItem,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BDropdownForm,
  BRow,
  BCol,
  

} from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import CreateCampaignModal from "@/views/campaigns/components/CreateCampaignModal.vue";
import CreateAdAccountModal from "@/views/settings/modal/CreateAdAccountModal.vue";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import vSelect from "vue-select";

import useJwt from "@/auth/jwt/useJwt";
import MyInfo from "@/views/settings/modal/MyInfo";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import AuthenticationService from "@/services/authentication.service";

import KeywordSearchModal from "@/views/cis-keywordsearch/KeywordSearchModal";

export default {
  name: "VerticalNavMenu",
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    CreateCampaignModal,
    CreateAdAccountModal,
    BLink,
    BImg,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormSelect,
    BFormRadio,
    vSelect,

    MyInfo,
    BNav,
    BNavItem,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BDropdownForm,
    BRow,
    BCol,

    KeywordSearchModal,


  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: "",
      searchKeyword: "",
      categoryList: [],
      // selectedAdaccount: "",
      selectedCategory: "",

      selectedMenu: "",

      createCampaignModalKey: Math.floor(Math.random() * 100),
      createAdAccountModalKey: Math.floor(Math.random() * 100),
      navMenuItems: [],

      editingId: null,
      editingMode: null,

      userData: useJwt.getUserData(),

      isActiveAiAgent: true,
    };
  },
  computed: {
    // check_selectedAdaccount(){return this.$store.getters.getSelectedAdAccount}

    check_activeMenu() {
      // if (this.$store.state.selectedCISMenu.length > 0) {
      //   this.selectedMenu = this.$store.state.selectedCISMenu
      //   return this.$store.state.selectedCISMenu
      // }
      return this.$store.getters.getSelectedCISMenu
    }
  },
  watch: {
    check_activeMenu(value) {
      this.selectedMenu = value
    },
    // check_selectedAdaccount(val){
    //   if(val != '0000'){
    //     this.setAdAccounts();
    //     this.setCampaigns();
    //   }
    // },
    // searchQuery() {
    //   this.setCampaigns();
    // },
    selectedCategory() {
      this.$store.dispatch('callMutation', { newSelectedCategory: this.selectedCategory.id })
      this.$store.dispatch('callCategoryCd', { newSelectedCategoryCd: this.selectedCategory.cd })
    },
  },
  methods: {
    openAbout(){
      window.open('https://consumerinsearch.com');
    },
    downGuide(){
      try {
          let element = document.createElement('a');
          element.setAttribute('href','/CIS_UserGuide.pdf');
          element.setAttribute('target','_blank');
          element.click();
      } catch(error) {
          console.log(error)
      }
    },
    keywordSearch(event){
      if(event.which === 13){
        console.log('enter!!!')
        console.log(this.searchKeyword)
        this.$refs.keywordSearchModal.loadData(1, '');
        this.$bvModal.show("keyword-search-modal");
        // v-b-modal.keyword-search-modal
      }
    },
    openMyInfo() {
      this.popupKey = Math.floor(Math.random() * 100);
      this.$nextTick(() => {
        this.$bvModal.show("my-info-modal");
      });
    },
    openSetting() {
      this.$refs["dropdown-user"].hide();
      if(this.userData.role.id < 3){ // admin
        // this.$router.push({ name: "admin-dash" }).catch(() => {});  
        this.selectedMenu = ''
        this.$router.push({ name: "cis-account" }).catch(() => {});  
      }
      // this.$router.push({ name: "account-info" }).catch(() => {});
    },
    async logout() {
      await AuthenticationService.logout();
      useJwt.logout();
      // redirect to login page
      this.$router.push({ name: "login" });
    },
    preparingMenu() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `Coming soon!`,
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
    showAiAgent() {
      this.$store.dispatch('callAiAgentVisibility', { visibility : true })
    },

    
    async setCategories() {

      console.log('====================== setCategories ==========================')
      console.log('adacctId : ', JSON.parse(localStorage.getItem('userData')).adacctId)
      console.log('===============================================================')

      const categories = await CategoryService.listCategories(JSON.parse(localStorage.getItem('userData')).adacctId);
      if (categories.data.success) {
        this.categoryList = categories.data.data;
        
        if (categories.data.data.length > 0){
          if (this.$store.getters.getSelectedCategory == '9999'){          
            this.selectedCategory = this.categoryList[0]
            this.$store.dispatch('callMutation', { newSelectedCategory: this.categoryList[0].id })
            this.$store.dispatch('callCategoryCd', { newSelectedCategoryCd: this.categoryList[0].cd })
          } else {
            const category = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, null);
            if (category.data.success) {
              this.selectedCategory = category.data.data;
            }
          }
        }
      }
    },
    cisMenuClick(mode) {      
      this.$store.dispatch('callCISMenu', { cisMenu: mode })

      switch(mode) {
        case 'marketoverview':
          this.$router.push({ path: "/" });
          break;
        case 'competition':
          this.$router.push({ path: "/competition" });
          break;
        case 'searchtag':
          this.$router.push({ path: "/searchtag" });
          break;
        case 'trendkeyword':
          this.$router.push({ path: "/trendkeyword" });
          break;
        case 'insight':
          this.$router.push({ path: "/insight" });
          break;
        case 'tracking':
          this.$router.push({ path: "/tracking" });
          break;
      }
    }
    
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
      // selectedAdaccount,
      selectedCategory,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage, voteLogoImage, uptrenixLogoImage } = $themeConfig.app;
    // const { appName } = $themeConfig.app;

    return {
      navSettingMenuItems,
      navTargetMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // selectedAdaccount,
      selectedCategory,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
      voteLogoImage, 
      uptrenixLogoImage,
    };
  },
  async created() {
    await this.setCategories();


  },
  mounted() {
    this.$root.$on("open-create-campaign", (id, mode) => {
      this.openCreateCampaignModal(id, mode);
    });
    this.$root.$on("set-login-info", () => {
      this.userData = useJwt.getUserData();
    });
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";

.header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
  min-width: 300px;
}

.btn-radio .btn {
  display: block;
}

#mainMenu .btn-radio .btn-secondary {
  background-color: #4E86FF !important;
  border-color: #4E86FF !important;
  box-shadow: none;
}

#mainMenu .btn-radio .btn-secondary.active {
  background-color: #1951dc !important;
  border-color: #1c5cff !important;
  box-shadow: 0 6px 30px -6px #002896;
  font-weight: 600;
  font-size: 1.3rem;
}

.custom-menu-elements {
  margin: 10px 10px;
}

.title-text {
  display: flex;
  align-items: center;
  color: $primary;
  margin-bottom: 0;
  font-weight: 600;
  letter-spacing: 0.001rem;
  font-size: 1.45rem;
  animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
}

// .adaccount-select {
//   font-size: large;

//   .vs__dropdown-toggle {
//     height: 80px;
//   }

//   ::v-deep .vs__selected-options {
//     flex-wrap: nowrap;
//   }

//   ::v-deep .vs__selected {
//     width: 100px;
//   }
// }

</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
